import confirmContentPagesRemovalOperation from 'editor/src/store/design/operation/spreadManipulation/confirmContentPagesRemovalOperation';
import pageCountSwitchLoss from 'editor/src/store/design/util/pageCountSwitchLoss';
import type { Thunk } from 'editor/src/store/hooks';
import getHostSetting from 'editor/src/store/hostSettings/selector/getHostSetting';
import isPageCountOptionsEnabled from 'editor/src/store/hostSettings/selector/isPageCountOptionsEnabled';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

import requestEcommerceVariantOperation from './requestEcommerceVariantOperation';

const setECommerceProductIdOperation =
  (newVariantId: string): Thunk =>
  (dispatch, getState) => {
    const state = getState();

    // A smaller page count drops the trailing spreads; a buyer is asked as when deleting them from
    // the spread menu. That answer settles the switch, so the host's own confirmation is not asked too.
    if (isPageCountOptionsEnabled(state) && !state.hostSettings.ignorePersonalizationLock) {
      const { pages, holdsContent } = pageCountSwitchLoss(state, newVariantId);
      if (holdsContent) {
        dispatch(
          confirmContentPagesRemovalOperation(pages, () => dispatch(requestEcommerceVariantOperation(newVariantId))),
        );
        return;
      }
    }

    const variantSwitchConfirmationEnabled = getHostSetting(state, 'variantSwitchConfirmationEnabled');
    const spreads = state.design.designData?.spreads || [];
    const designDataTouched = spreads.some((spread) => !!spread.pages?.[0].groups.media?.length);
    if (!variantSwitchConfirmationEnabled || !designDataTouched) {
      dispatch(requestEcommerceVariantOperation(newVariantId));
    } else {
      sendPostMessage('variants.requestECommerceVariantDesignToValidate', { gelatoVariantId: newVariantId });
    }
  };

export default setECommerceProductIdOperation;
